import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * A utility function to conditionally combine and merge Tailwind CSS class names.
 *
 * @param classes - The class names to be combined and merged.
 * @returns A single string of merged class names with conflicts resolved.
 */
export const mergeTailwindClasses = (...classes: ClassValue[]) => {
  return twMerge(clsx(...classes));
};
